import { render, staticRenderFns } from "./NovelDetailPage.vue?vue&type=template&id=005cf4ad&"
import script from "./NovelDetailPage.vue?vue&type=script&lang=ts&"
export * from "./NovelDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports